import React from "react";
import "./ProofSection.css";
import { FaUniversity, FaShoppingCart, FaHeartbeat } from "react-icons/fa";

const metrics = [
  { value: "25+", label: "Major transformations delivered" },
  { value: "$1.3B+", label: "Value unlocked for our clients" },
  { value: "30%", label: "Average EBITDA improvement" },
  { value: "9–12 Mo.", label: "Time to measurable impact" },
];

const outcomes = [
  {
    icon: <FaUniversity />,
    title: "Global Manufacturing Company",
    desc: "Re-architected operating model and data platform with embedded AI across 30+ markets.",
    stat: "$100M+",
    statLabel: "Value unlocked",
  },
  {
    icon: <FaShoppingCart />,
    title: "Global Retailer",
    desc: "Transformed supply chain and demand planning using AI-powered decision systems.",
    stat: "35%",
    statLabel: "Increase in operating margin",
  },
  {
    icon: <FaHeartbeat />,
    title: "Leading Healthcare and Wellness Company",
    desc: "Built an AI-driven care operations platform improving patient outcomes and efficiency.",
    stat: "20%",
    statLabel: "Improvement in patient outcomes",
  },
];

export default function ProofSection() {
  return (
    <section className="proof">
      <div className="proof-container">

        {/* ── LEFT ── */}
        <div className="proof-left">
          <p className="proof-eyebrow">Proof That Matters</p>

          <h2 className="proof-heading">
            Real transformations.<br />
            Measurable impact.
          </h2>

          {/* 4 metrics in a single horizontal row */}
          <div className="proof-metrics">
            {metrics.map((m, i) => (
              <div className="proof-metric" key={i}>
                <h3>{m.value}</h3>
                <p>{m.label}</p>
              </div>
            ))}
          </div>

          {/* Testimonial */}
          <div className="proof-testimonial">
            <p className="proof-quote">
              <span className="proof-quote-mark">&ldquo;</span>
              BaiRees didn't just help us adopt AI. They re-architected how we
              operate—unlocking scale, speed and real business value.
            </p>
            <p className="proof-author">
              — Chief Digital Officer, Global Retail Enterprise
            </p>
          </div>
        </div>

        {/* ── RIGHT ── */}
        <div className="proof-right">
          <p className="proof-right-label">Selected Outcomes (Anonymized)</p>

          <div className="proof-outcomes">
            {outcomes.map((o, i) => (
              <div className="proof-outcome" key={i}>
                <div className="proof-outcome-icon">{o.icon}</div>
                <div className="proof-outcome-text">
                  <h4>{o.title}</h4>
                  <p>{o.desc}</p>
                </div>
                <div className="proof-outcome-result">
                  <h3>{o.stat}</h3>
                  <p>{o.statLabel}</p>
                </div>
              </div>
            ))}
          </div>

          <a href="#" className="proof-more">
            View more success stories &rarr;
          </a>
        </div>

      </div>
    </section>
  );
}